module.exports = __webpack_public_path__ + "img/nav_entry.93b14f33.png";